
import { Slide } from 'smartstream-widgets/controls/Carousel/Carousel'
import { MessageBusType, WidgetProps } from 'smartstream-widgets/types/sharedModule/core'

type Fixture = {
  competitionId: string,
  fixtureId?: string,
  sportId?: string
}

type State = Readonly<{
  widgetData: Array<Fixture>
}>

export function dispatchWidgetDataChanged (messageBus: MessageBusType, fixture: Fixture) {
  const { fixtureId, competitionId, sportId } = fixture || {}
  messageBus.dispatchEvent('widget:dataChanged', {
    fixtureId, competitionId, sportId
  })
}


export function getOnSlideRenderHandler<T extends State>  (props: WidgetProps, state: T) {
  const { messageBus } = props
  if (messageBus) {
    return (slide: Slide) => {
      if (!slide.isAdvert) {
        dispatchWidgetDataChanged(messageBus, state.widgetData[slide.index])
      }
    }
  }
}
